import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {Store} from "@ngrx/store";
import {AppState} from "../../store/store";
import {Observable} from "rxjs";
import {selectNotifications} from "../../store/notificationCenter/notificationCenter.selectors";
import {NotificationComponentObject} from "../../classes/notification-component-object";
import {MatMenuTrigger} from "@angular/material/menu";
import {NotificationCenterStore} from "./notification-center.store";

@Component({
  selector: 'app-notification-center',
  templateUrl: './notification-center.component.html',
  styleUrls: ['./notification-center.component.scss'],
  providers: [NotificationCenterStore]
})
export class NotificationCenterComponent implements AfterViewInit {
  @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;

  public readonly notifications$: Observable<NotificationComponentObject[]> = this._store.select(selectNotifications);

  constructor(
    protected _store: Store<AppState>,
    private readonly _notificationCenterStore: NotificationCenterStore
  ) {}

  public ngAfterViewInit(): void {
    this._notificationCenterStore.initClose(this.menuTrigger);
  }
}
